module.exports = __webpack_public_path__ + "img/华南理工.8f331318.png";